/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DistributionChannelListQuery,
    DistributionChannelListQueryFromJSON,
    DistributionChannelListQueryToJSON,
    DistributionChannelListResponse,
    DistributionChannelListResponseFromJSON,
    DistributionChannelListResponseToJSON,
} from '../models';

export interface ApiDistributionChannelListDataPostRequest {
    distributionChannelListQuery?: DistributionChannelListQuery;
}

/**
 * no description
 */
export class DistributionChannelListApi extends runtime.BaseAPI {

    /**
     */
    async apiDistributionChannelListDataPostRaw(requestParameters: ApiDistributionChannelListDataPostRequest): Promise<runtime.ApiResponse<DistributionChannelListResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/DistributionChannelList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DistributionChannelListQueryToJSON(requestParameters.distributionChannelListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DistributionChannelListResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiDistributionChannelListDataPost(requestParameters: ApiDistributionChannelListDataPostRequest): Promise<DistributionChannelListResponse> {
        const response = await this.apiDistributionChannelListDataPostRaw(requestParameters);
        return await response.value();
    }

}
